module.exports = __webpack_public_path__ + "img/voiceprint.9f00c2fd.png";